<div class="ui-g">
  <div class="ui-g-12 text-right">
    <button pButton type="button" class="k-generic-btn" icon="fa fa-magic" iconPos="left" routerLink="/roles-management" label="{{ 'rolesManagement.rolesManagement' | translate }}"></button>
  </div>
</div>


<div class="ui-fluid ui-g-12">
  <app-kontable
  #rolesCreation
  title="{{ 'rolesManagement.commonRolesTitle' | translate }}"
  [columns]="[{field: 'id', title: 'common.id'}, {field: 'description', title: 'common.description'}]"
  [source]="commonRoles"
  [showInfoButton]="false"
  [showRecoverButton]="false"
  [showDetailsButton]="false"
  [showAddButton]="true"
  [showEditButton]="true"
  [showDeleteButton]="false"
  [showReport]="false"
  [showGlobalFilter]="false"
  (onAdd)="showAddOrEditDialog($event)"
  (onEdit)="showAddOrEditDialog($event)"
>
</app-kontable>

<p-dialog
        *ngIf="openPopUp"
        [(visible)]="openPopUp"
        [modal]="true"
        header="{{'rolesManagement.rolesCreationPopUpTitle' | translate}}"
        [minWidth]="500"
        [draggable]="false"
        [resizable]="false"
        (onHide)="closeDialog()">
        <form *ngIf="addEditForm && roleField" [formGroup]="addEditForm" [ngClass]="{'invalid-submit': invalidSubmit}" (ngSubmit)="saveOrUpdate()" RestrictFocus>
          <div class="ui-grid ui-grid-responsive ui-fluid Loyalty" >
            <div class="ui-grid-row margin-bottom">
              <div class="ui-grid-col-4"><label [ngClass]="{'required': !roleField.descr.nullable}">{{ roleField.descr.keyName }}</label></div>
              <div class="ui-grid-col-8">
                <input id="description" name="description" formControlName="descr" type="text" pInputText />
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="roleField.descr"></app-validation-msg>
              </div>
            </div>
          </div>
          <p-footer>
            <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0;">
              <br />
              <button id="addBrand" name="addBrand" class="k-generic-btn" type="submit" pButton icon="fa fa-check"
                      label="{{update ? ('common.edit' | translate) :  ('common.add' | translate) }}"></button>
            </div>
          </p-footer>
        </form>
        
</p-dialog>

</div>



// WEBPACK FOOTER //
// ./src/app/views/administration/roles-creation/roles-creation.component.html